import { React, useState, useEffect } from "react";
import {
  Box,
  Typography,
  useMediaQuery,
  Card,
  Divider,
  Skeleton
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import ErrorIcon from '@mui/icons-material/Error';
import Tooltip from '@mui/material/Tooltip';

const DataTable = ({ staffData }) => {
  const [isLoading, setIsLoading] = useState(true);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("lg"));

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }, []);

  return (
    <>
      <Card
        variant="outlined"
        sx={{
          backgroundColor: "white.main",
          width: "100%",
          maxHeight: "300px",
          overflow: "auto",
        }}
      >
        {staffData && staffData.staff.map((item, index) => (
          <>
            {isLoading ? (
              matches ? (
                <>
                  <Box width={"100%"} display={"flex"}>
                    <Box p={2} mr={6}>
                      <Skeleton height={30} width={150} />
                    </Box>
                    <Box p={2} mr={6}>
                      <Skeleton height={30} width={150} />
                    </Box>
                    <Box p={2} mr={6}>
                      <Skeleton height={30} width={150} />
                    </Box>
                    <Box p={2}>
                      <Skeleton height={30} width={150} />
                    </Box>
                  </Box>
                  <Divider light />
                </>
              ) : (
                <>
                  <Box display={"flex"} flexDirection={"row"} width="100%">
                    <Box p={2} width="50%">
                      <Skeleton height={50} width={"100%"} />
                    </Box>
                    <Box p={2} width="50%">
                      <Skeleton height={50} width={"100%"} />
                    </Box>
                  </Box>

                  <Divider light />
                </>
              )
            ) : (
              <>
                {" "}
                <Box
                  py={2}
                  px={3}
                  key={index}
                  display={"flex"}
                  alignItems={"center"}
                >
                  <Box
                    sx={{ minWidth: "150px" }}
                    width={1 / 4}
                    display={"flex"}
                    flexDirection={"row"}
                    alignItems={"center"}
                  >
                    {item.errors.length !== 0 &&
                      <Tooltip
                        componentsProps={{
                          tooltip: {
                            sx: {
                              whiteSpace: "pre-wrap",
                            }
                          }
                        }}
                        title={item.errors.length > 1 ?
                          item.errors.map((layout, order) => {
                            return (order + 1) + ") " + layout + "\n"
                          })
                          :
                          item.errors[0]
                        }
                        placement="bottom-start"
                      >
                        <ErrorIcon sx={{ color: "error.main", mr: 1.25 }} />
                      </Tooltip>
                    }
                    <Typography variant="subtitle1" color="dark-gray-text.main">
                      {item.name}
                    </Typography>
                  </Box>

                  <Box sx={{ minWidth: "200px" }} width={1 / 4}>
                    <Typography
                      variant="subtitle1"
                      color={
                        (item.errors !== 0) ?
                        item.errors.find((bool) => bool === "A staff with this email already exists") ?
                          "error.main"
                          :
                          "dark-gray-text.main"
                        :
                        "dark-gray-text.main"
                      }
                    >
                      {item.email}
                    </Typography>
                  </Box>

                  <Box sx={{ minWidth: "150px" }} width={1 / 4}>
                    <Typography
                      align="center"
                      variant="subtitle1"
                      color="dark-gray-text.main"
                    >
                      {item.designation}
                    </Typography>
                  </Box>
                  <Box sx={{ minWidth: "150px" }} width={1 / 4}>
                    <Typography
                      align="center"
                      variant="subtitle1"
                      color={
                        (item.errors !== 0) ?
                        item.errors.find((bool) => bool === "This department does not exist") ?
                          "error.main"
                          :
                          "dark-gray-text.main"
                        :
                        "dark-gray-text.main"
                      }
                    >
                      {item.department}
                    </Typography>
                  </Box>
                </Box>
                <Divider light />
              </>
            )}
          </>
        ))}
      </Card>
    </>
  );
};

export default DataTable;
